<div class="error">
  <div class="error-icon">
    <i class="fas fa-exclamation-circle"></i>
  </div>
  <h2>{{ title || ('common.error' | transloco) }}</h2>
  <p>{{ message || ('common.somethingWentWrong' | transloco) }}</p>
  <div class="error-actions">
    <button *ngIf="showRetry" class="btn btn--primary" (click)="onRetry()">{{ 'common.retry' | transloco }}</button>
    <a *ngIf="showBackLink" [routerLink]="backLinkRoute" class="btn btn--primary">{{ backLinkText || ('button.back' | transloco) }}</a>
  </div>
</div>
